import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';

var createCache = function createCache(cache) {
  if (cache === void 0) {
    cache = {};
  }

  return {
    _cache: cache,
    get: function get(flags) {
      var hasAllRequestedCachedFlags = flags.every(function (cachedFlagKey) {
        return cache[cachedFlagKey] !== undefined;
      });

      if (!hasAllRequestedCachedFlags) {
        return null;
      }

      return flags.reduce(function (accumulator, flagKey) {
        var _extends2;

        return _extends({}, accumulator, (_extends2 = {}, _extends2[flagKey] = cache[flagKey], _extends2));
      }, {});
    },
    set: function set(flags) {
      Object.keys(flags).forEach(function (flagKey) {
        cache[flagKey] = flags[flagKey];
      });
    },
    toJSON: function toJSON() {
      return JSON.stringify(cache);
    }
  };
};

export default createCache;
//# sourceMappingURL=createCache.esm.js.map
